import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=3c6092ac&scoped=true&"
import script from "./Subcategory.vue?vue&type=script&lang=js&"
export * from "./Subcategory.vue?vue&type=script&lang=js&"
import style0 from "./Subcategory.vue?vue&type=style&index=0&id=3c6092ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6092ac",
  null
  
)

export default component.exports